import { api } from "@/api";
const invoiceStore = {
  state: {
    invoices: [],
    invoicesPaymentsMethod: ["cheque", "comptant", "debit", "credit", "autre"]
  },
  getters: {
    getInvoices(state) {
      return state.invoices;
    },
    getInvoicesPaymentsMethod(state) {
      return state.invoicesPaymentsMethod;
    }
  },
  mutations: {
    setInvoices(state, value) {
      state.invoices = value;
    },
    addInvoice(state, value) {
      state.invoices.push(value);
    }
  },
  actions: {
    async loadInvoices(context) {
      try {
        const res = await api.getInvoices();
        context.commit("setInvoices", res);
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async addInvoice(context, payload) {
      const res = await api.postInvoice(payload);
      context.commit("addInvoice", res);
    }
  }
};

export default invoiceStore;
